export const LEFT_SIDE_CONTAINER_TEST_ID = 'software-backlog.card-list.left-side';
export const COLUMN_LIMIT_TEST_ID = 'software-backlog.card-list.column-limit';
